export class ADAMIntegrationConfig {
    url?: string;
    apiKey?: string;
    username?: string;
    password?: string;
    domain?: string;

    constructor(config) {
        let _config = config || {};
        this.url = _config.url || "";
        this.apiKey = _config.apiKey || "";
        this.username = _config.username || "";
        this.password = _config.password || "";
        this.domain = _config.domain || "";
    }
}

export class ADAMIntegration {
    config: ADAMIntegrationConfig;
    name: string;
    integrationDirection: number;
    integrationType: number;
    integrationId: number;
    triggerId: string;
    triggerLastRun: string;
    triggerEnabled: boolean;
    organizationId: string;
    priority: number;

    constructor(integration: any = {}) {
        this.name = integration.name || "";
        this.integrationDirection = integration.integrationDirection;
        this.integrationType = integration.integrationType;
        this.integrationId = integration.integrationId;
        this.triggerId = integration.triggerId;
        this.triggerLastRun = integration.triggerLastRun;
        this.triggerEnabled = integration.triggerEnabled;
        this.organizationId = integration.organizationId;
        this.priority = integration.priority;

        this.config = new ADAMIntegrationConfig(integration.config);
    }
}
